import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';

class SportMessages extends Component {
    componentDidMount() {
        this.props.dispatch(Action.get('SportMessages'));
    }

    render() {
        let {messages} = this.props;
        let rows = [];
        if (messages && messages.length > 0) {
            messages.map((message) => {
                rows.push(
                    <div className="message-alert mb25" key={message.id}>
                        <div className="text-left">
                            <strong>{message.content}</strong>
                        </div>
                    </div>,
                );
            });
        } else {
            return false;
        }

        return <div>{rows}</div>;
    }
}

function mapStatesToProps(state) {
    return {
        messages: state.messagesData.messages.sportData,
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(SportMessages);
